export const SET_ADDRESS_LIST = "SET_ADDRESS_LIST";
export const SET_ADDRESS_LOADING = "SET_ADDRESS_LOADING";
export const SET_DELIVERY_SHIFT_RESTRICTIONS_FOR_STORE =
  "SET_DELIVERY_SHIFT_RESTRICTIONS_FOR_STORE";
export const SET_DELIVERY_SHIFT_RESTRICTIONS_LOADING =
  "SET_DELIVERY_SHIFT_RESTRICTIONS_LOADING";
